import React from "react";

const Hero = () => {
  return (
    <div className="">
      <div className="max-w-7xl mx-auto">
        {/* Hero Section */}
        <div className="container mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-2/3 mb-12 md:mb-0 text-center md:text-left">
            <h1 className="text-4xl md:text-7xl lg:text-[90px] leading-tight font-normal mb-4 md:mb-8">
              <div className="">Scaling Startups,</div>
              <div className="text-white font-semibold" style={{ animationDelay: "0.2s" }}>
                Accelerating
              </div>
              <div className="" style={{ animationDelay: "0.4s" }}>
                Growth
              </div>
            </h1>
            <p className="text-xl md:text-3xl lg:text-[32px] leading-relaxed md:mb-8 mb-6 " style={{ animationDelay: "0.6s" }}>
              Your Partner in Startup Success
            </p>

            {/* <img
              src="img/plantcapsule.png"
              alt="Growth Visualization"
              className="w-56 inline md:hidden h-auto animate-float"
            /> */}

            <a
              href="https://forms.gle/Brpzz6dAtLtcTYc9A"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
              style={{ animationDelay: "0.8s" }}
            >
              <button className="bg-white text-blue-600 font-semibold text-lg md:text-xl py-3 px-8 rounded-full hover:bg-blue-100 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                Start Your Journey
              </button>
            </a>

          </div>
          <div className="md:w-1/3 hidden md:flex justify-center">
            <img
              src="img/plantcapsule.png"
              alt="Growth Visualization"
              className="w-full max-w-md h-auto animate-float"
            />
          </div>
        </div>

        {/* Second Section */}
        <div className="container mx-auto px-6 md:px-12 md:mt-16">
          <h2 className="text-3xl md:text-5xl lg:text-[48px] leading-tight mb-6 text-gray-300">
            We Are <span className="font-bold text-white">Turning Ideas</span>
          </h2>

          <div className="flex flex-col gap-8 md:flex-row items-center justify-between">

            <div className="md:w-1/3 mb-8 md:mb-0 text-left hidden md:block">
              <div className="mt-6">
                <img
                  src="img/people.png"
                  alt="Innovative idea"
                  className="w-full h-auto"
                />
              </div>
            </div>

            <div className="md:w-2/3 text-left md:pl-10">
              <div className="max-w-2xl">
                <p className="mb-2 text-lg md:text-xl lg:text-[26px] leading-relaxed">
                  Turning Ideas is a startup studio helping global startups scale in India
                  and Indian startups
                </p>
                <p className="mb-6 text-sm md:text-md lg:text-[18px] font-light leading-relaxed">
                  accelerate growth in Asia through strategy, sales, and product development.
                </p>
                <hr className="border-gray-300" />

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-6">
                  <a href="/global" className="border border-white bg-opacity-50 rounded-lg px-6 py-4 shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer block hover:scale-105 hover:border-white hover:bg-white hover:text-blue-600">
                    <p className="font-medium text-md mb-1">For Global Startups</p>
                    <p className="text-sm ">Navigate & expand in India</p>
                  </a>

                  <a href="/indian" className="border border-white bg-opacity-50 rounded-lg px-6 py-4 shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer block hover:scale-105 hover:border-white hover:bg-white hover:text-blue-600">
                    <p className="font-medium text-md mb-1">For Indian Startups</p>
                    <p className="text-sm">Grow in Asia</p>
                  </a>

                  <a href="/enterprise" className="border border-white bg-opacity-50 rounded-lg px-6 py-4 shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer block hover:scale-105 hover:border-white sm:col-span-2 md:col-span-1 hover:bg-white hover:text-blue-600">
                    <p className="font-medium text-md mb-1">For Enterprises</p>
                    <p className="text-sm ">Connect with innovative startups</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add animation styles */}
      <style jsx>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
          100% { transform: translateY(0px); }
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease forwards;
        }
        
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default Hero;